module.exports = __webpack_public_path__ + "static/media/search.f97bb0d7.svg";